import { TCallbackFunction } from "../../interfaces/common"
import { useAppActions } from "../../stores/application/useAppActions"
import { useAppStore } from "../../stores/application/useAppStore"

export interface IChromeRuntimeMessageParams {
    enabled?: boolean,
    slug: string
    url: string
    action: 'action' | 'linkedinAction'
    params?: Object
    payload?: Object,
    errorClb?: TCallbackFunction<any>
    displayToast?: boolean;
    all?: boolean;
}

const sendChromeMessage = (data: any, extensionId: string) => new Promise((resolve, reject) => {
    try {
        const runtime = (window as any).chrome?.runtime

        if (!runtime?.sendMessage) {
            console.warn('[chromeRuntime] chrome.runtime.sendMessage nije dostupan (extensionId =', extensionId, ')')
            return reject(new Error('chrome.runtime.sendMessage nije dostupan u ovoj kartici (ekstenzija nije instalirana / dostupna).'))
        }

        runtime.sendMessage(extensionId, data, (response: any) => {
            const lastError = runtime.lastError
            if (lastError) {
                const message = typeof lastError === 'string' ? lastError : (lastError?.message ?? String(lastError))
                console.error('[chromeRuntime] runtime.lastError', { lastError, message, action: data?.action ?? data?.linkedinAction })
                return reject(new Error(`Chrome runtime: ${message}`))
            }

            if (response?.error && typeof response.error === 'string') {
                return reject(new Error(response.error))
            }
            return resolve(response)
        })
    } catch (error) {
        console.error('[chromeRuntime] sendMessage threw', error)
        return reject(error instanceof Error ? error : new Error(String(error)))
    }
})

export const useChromeRuntime = () => {
    const { setRequestLoading, setToast } = useAppActions()
    const { store: { extensionId } } = useAppStore()

    const sendMessage = async ({ slug, url, action, payload, all = false, displayToast = false, enabled = true}: IChromeRuntimeMessageParams) => {   
        try {
            setRequestLoading({ [slug]: true });

            if (!enabled) throw Error("Forbidden!");

            const data: any = await sendChromeMessage({
                [action as string]: url,
                ...payload
            }, extensionId)
            console.log("Valid response", data)

            if (displayToast) setToast({ type: 'success', message: "Action succeeded!" });

            return all ? data : data?.result;
        }
        catch (error) {
            if (displayToast) setToast({ type: 'error', message: "There was a problem performing this action!" });
            return all ? error : false;
        }
        finally {
            setRequestLoading({ [slug]: false })
        }
    };
    return { sendMessage }
}